var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0275 0 0 4.0275 0 9C0 13.9725 4.0275 18 9 18C13.9725 18 18 13.9725 18 9C18 4.0275 13.9725 0 9 0ZM9 16.2C5.022 16.2 1.8 12.978 1.8 9C1.8 7.335 2.3715 5.8095 3.3165 4.59L13.41 14.6835C12.1905 15.6285 10.665 16.2 9 16.2ZM14.6835 13.41L4.59 3.3165C5.8095 2.3715 7.335 1.8 9 1.8C12.978 1.8 16.2 5.022 16.2 9C16.2 10.665 15.6285 12.1905 14.6835 13.41Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRequired);
export default __webpack_public_path__ + "static/media/not-required.3ef86dd4d1f08825ca1fdd13f001fee7.svg";
export { ForwardRef as ReactComponent };